import { NumericValueOfNotAvailable, StringValueOfNotAvailable } from './constants';

export const formatCharge = (charge) => {
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  return charge === NumericValueOfNotAvailable ? StringValueOfNotAvailable : currencyFormatter.format(charge);
};

export const formatQuantity = (quantity) => {
  const quantityFormatter = new Intl.NumberFormat('en-US');
  return quantity === NumericValueOfNotAvailable ? StringValueOfNotAvailable : quantityFormatter.format(quantity);
};
